import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!DSN) {
    console.info("[Sentry] VITE_SENTRY_DSN not set – skipping initialisation.");
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: (import.meta.env.VITE_APP_ENV as string) || import.meta.env.MODE || "development",
    release: `commandx@0.0.0`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      "ResizeObserver loop",
      "ResizeObserver loop completed with undelivered notifications",
      "Network request failed",
      "Load failed",
      "Failed to fetch",
      "NetworkError",
      "AbortError",
      "TimeoutError",
      "TypeError: cancelled",
      "TypeError: Cancelled",
      "Non-Error promise rejection captured",
    ],
    beforeBreadcrumb(breadcrumb) {
      // Drop noisy xhr/fetch breadcrumbs for analytics pings
      if (breadcrumb.category === "xhr" && breadcrumb.data?.url?.includes("/analytics")) {
        return null;
      }
      return breadcrumb;
    },
  });
}

/** Call after successful login */
export function setSentryUser(user: { id: string; email?: string | null }) {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined });
}

/** Call on logout */
export function clearSentryUser() {
  Sentry.setUser(null);
}

/** Add a breadcrumb for key financial actions */
export function addFinancialBreadcrumb(
  action: string,
  data?: Record<string, unknown>,
) {
  Sentry.addBreadcrumb({
    category: "financial",
    message: action,
    level: "info",
    data,
  });
}
